class MarqueePhotos extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.marquee-photos__track');
    this.items = this.querySelector('.marquee-photos__items');

    if (!this.track || !this.items) return;

    const speed     = this.dataset.speed     || 25;
    const direction = this.dataset.direction || 'reverse';

    const clone = this.items.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    this.track.appendChild(clone);

    this.track.style.setProperty('--marquee-speed', `${speed}s`);
    this.track.style.setProperty('--marquee-dir', direction);

    this.addEventListener('mouseenter', () => {
      this.track.style.animationPlayState = 'paused';
    });
    this.addEventListener('mouseleave', () => {
      this.track.style.animationPlayState = 'running';
    });
  }
}

customElements.define('marquee-photos', MarqueePhotos);